import { UserPermissions } from '@centecomm/portal-service';
import { FeatureConfiguration } from 'Core/Types/FeatureConfiguration';
import React from 'react';
import { LoadingContent } from 'Shared/PageElements/LoadingContent';
import CommunicationsNavigationIcon from '../../Icons/NavigationItem/Communications';

const LazyCommunicationsPage = React.lazy(() => import('./Pages/CommunicationsPage'));
const LazyNewsPage = React.lazy(() => import('./Pages/NewsPage'));

const communicationsConfiguration: FeatureConfiguration = {
    name: 'Communications',
    navigationItem: {
        route: {
            text: 'common:sidebar.featureCommunicationTitle',
            url: '/communications',
            Icon: CommunicationsNavigationIcon,
            ownerOperatorRoot: (
                <React.Suspense fallback={<LoadingContent />}>
                    <LazyCommunicationsPage />
                </React.Suspense>
            ),
            tenantRoot: (
                <React.Suspense fallback={<LoadingContent />}>
                    <LazyNewsPage />
                </React.Suspense>
            ),
        },
        permissions: [UserPermissions.ViewNews],
    },
    disableFeature: [],
    checkIfEnabledViaSettings: (settings) => {
        if (settings && settings.communication) {
            return settings.communication.visible;
        }

        return false;
    },
};

export default communicationsConfiguration;
